import env from '../config/env';
import shoppingCreditDTO from '../interfaces/dto/shoppingCreditDTO';
import { get } from '../utils/api';
import { apiPaths } from '../utils/apiPaths';

const getShoppingCredit = (): Promise<shoppingCreditDTO> => {
  const url = apiPaths.getShoppingCredit;
  return get(env.ACE_API_URL, url).then((response) => response.data);
};

export { getShoppingCredit };
